/* eslint-disable class-methods-use-this */
import Axios from 'axios';
import store from '../store';

// @todo Interceptors!
export default class BaseService {
  get(url) {
    return Axios.get(
      store.state.API_URL + url,
      {
        headers: {
          Authorization: 'Bearer '.concat(store.state.accessToken)
        }
      }
    );
  }

  create(url, data, time) {
    return Axios.post(
      store.state.API_URL + url,
      data,
      {
        headers: {
          Authorization: 'Bearer '.concat(store.state.accessToken)
        },
        timeout: time ?? 0
      }
    );
  }

  update(url, data) {
    return Axios.put(
      store.state.API_URL + url,
      data,
      {
        headers: {
          Authorization: 'Bearer '.concat(store.state.accessToken)
        }
      }
    );
  }

  delete(url) {
    return Axios.delete(
      store.state.API_URL + url,
      {
        headers: {
          Authorization: 'Bearer '.concat(store.state.accessToken)
        }
      }
    );
  }

  createWithNoHeader(url, data) {
    return Axios.post(store.state.API_URL + url, data);
  }
}
